import { generateExpWithNum } from '../../utils/generateExpWithNum';
import { declensions } from '../../constants/declensions';

const generateContent = (count, declensions) =>
  generateExpWithNum(count, declensions);

const declensionsMap = {
  houses: declensions.houses,
  porchs: declensions.porchs,
  flats: declensions.flats,
  clients: declensions.residents,
  aliveClients: declensions.aliveResidents,
};

export const getSubtitle = (houses) => {
  const init = {
    houses: houses.length,
    porchs: 0,
    flats: 0,
    clients: 0,
    aliveClients: 0,
  };

  const counts = houses.reduce((acc, house) => {
    if (house.porchCount) {
      acc.porchs += house.porchCount;
    }

    if (house.flatCount) {
      acc.flats += house.flatCount;
    }

    if (house.clientCount) {
      acc.clients += house.clientCount;
    }

    if (house.aliveClientCount) {
      acc.aliveClients += house.aliveClientCount;
    }

    return acc;
  }, init);

  const subtitle = Object.entries(counts).reduce((acc, [key, value]) => {
    if (acc === '') {
      return generateContent(value, declensionsMap[key]);
    }

    return `${acc} / ${generateContent(value, declensionsMap[key])}`;
  }, '');

  return subtitle;
};
